import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components/macro';
import { theme } from 'styled-tools';
import { Link, NavLink } from 'react-router-dom';

const UserNavDetails = styled.span`
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;

const MyAccountToggle = styled(DropdownToggle)`
  margin-left: 1rem;
  &&& {
    color: ${theme('colors.black')};
    &:hover {
      color: ${theme('colors.black')};
      text-decoration: none;
    }
  }
`;

const StyledNavLink = styled(NavLink)`
  color: ${theme('colors.primary')};

  &:hover {
    text-decoration: none;
    color: ${theme('colors.primary')};
  }
`;

const StyledDropdownItem = styled(DropdownItem)`
  &:hover {
    background: #e9ecef;
    text-decoration: none;
  }
`;

const ProfileIcon = styled(FontAwesomeIcon).attrs({
  icon: faUserCircle,
})``;

function MyAccountMenu({ isMobile = false, toggleNav }) {
  return (
    <UncontrolledDropdown nav inNavbar>
      <MyAccountToggle nav caret>
        <ProfileIcon title='My Account' />
        <UserNavDetails>My Account</UserNavDetails>
      </MyAccountToggle>
      <DropdownMenu right>
        {!isMobile ? (
          <>
            <StyledDropdownItem tag={Link} to='/profile'>
              My Profile
            </StyledDropdownItem>
            <StyledDropdownItem tag={Link} to='/logout'>
              Logout
            </StyledDropdownItem>
          </>
        ) : (
          <>
            <StyledDropdownItem>
              <StyledNavLink className='nav-link' to='/profile' onClick={toggleNav}>
                My Profile
              </StyledNavLink>
            </StyledDropdownItem>
            <StyledDropdownItem>
              <StyledNavLink className='nav-link' to='/logout' onClick={toggleNav}>
                Logout
              </StyledNavLink>
            </StyledDropdownItem>
          </>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

MyAccountMenu.propTypes = {
  isMobile: PropTypes.bool,
  toggleNav: PropTypes.func,
};

export default MyAccountMenu;
